import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Lock, ArrowLeft } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Link } from "react-router-dom";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-[80vh] flex items-center justify-center px-6 py-16">
      <div className="w-full max-w-md bg-[#F4EFE6] border border-[#A39171]/15 rounded-3xl p-8 md:p-10">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-[#5C524E] hover:text-[#E07A5F] mb-8">
          <ArrowLeft className="w-4 h-4" /> Back to site
        </Link>
        <div className="w-12 h-12 rounded-2xl bg-[#2D2623] text-[#FDFBF7] flex items-center justify-center mb-5">
          <Lock className="w-5 h-5" />
        </div>
        <p className="eyebrow text-[#A39171] mb-2">Admin Access</p>
        <h1 className="font-display text-3xl text-[#2D2623] tracking-tight">Sign in to manage Manas</h1>

        <form onSubmit={submit} className="mt-8 space-y-4">
          <div>
            <Label className="text-sm text-[#5C524E] mb-2 block">Email</Label>
            <Input
              data-testid="admin-login-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="bg-white/70 border-[#A39171]/30 rounded-xl h-12 focus-visible:ring-[#E07A5F]/50"
              placeholder="admin@manashospital.com"
            />
          </div>
          <div>
            <Label className="text-sm text-[#5C524E] mb-2 block">Password</Label>
            <Input
              data-testid="admin-login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="bg-white/70 border-[#A39171]/30 rounded-xl h-12 focus-visible:ring-[#E07A5F]/50"
              placeholder="••••••••"
            />
          </div>
          {error && (
            <p data-testid="admin-login-error" className="text-sm text-[#E07A5F] bg-[#E07A5F]/10 px-4 py-3 rounded-xl">
              {error}
            </p>
          )}
          <Button
            data-testid="admin-login-submit"
            type="submit"
            disabled={loading}
            className="w-full rounded-full bg-[#2D2623] hover:bg-[#E07A5F] text-[#FDFBF7] h-12 font-medium mt-2"
          >
            {loading ? "Signing in…" : "Sign in"}
          </Button>
        </form>
      </div>
    </div>
  );
}
